import { createGlobalStyle } from 'styled-components';
import fonts from '../fonts';

const css = props => {
  const {
    theme: { font: fontFaces },
  } = props;

  return Object.values(fontFaces).reduce((aggregate, font) => {
    const obj = fonts[font];
    if (obj && (typeof obj === 'string' || Array.isArray(obj))) {
      return aggregate + obj;
    }
    return aggregate;
  }, '');
};

const GlobalStyle = createGlobalStyle`
    ${css}
    body {
      font-family: ${props => props.theme.font.circular};
      font-size: ${props => props.theme.fontSize.normal};
      color: ${props => props.theme.text.normal};
      background-color: ${props => props.theme.background.normal};
      box-sizing: border-box;
      -webkit-font-smoothing: antialiased;
      -moz-osx-font-smoothing: grayscale;
    }
    *, *:before, *:after {
      -webkit-box-sizing: border-box;
      -moz-box-sizing: border-box;
      box-sizing: border-box;
    }
  `;

export default GlobalStyle;
